import React from 'react';
import { Button } from 'reactstrap';

const AdminTable = ({
  records,
  headerFields,
  formatField,
  openModal,
  readOnly }) => {
  return (
    <table className="table">
      <thead>
        <tr>
          {headerFields.map(field => (
            <th key={field}>{formatField(field)}</th>
          ))}
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {records.map(entity => (
          <tr key={entity.key}>
            {headerFields.map(field => {
              let record;
              if (field.endsWith('date')) {
                record = new Date(entity[field]).toLocaleDateString();
              } else {
                record = entity[field];
              }
              return <td key={field}>{record}</td>
            })}
            <td className='action-buttons'> 
              {readOnly.includes(entity.id) ?
              <div className="buttons-placeholder"> </div>:
              <React.Fragment>
              <Button className='btn-info' onClick={() => openModal('edit', entity)}>Edit</Button>
              <Button className='btn-danger ml-2' onClick={() => openModal('delete', entity)}>Remove</Button>
              </React.Fragment>
            }
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AdminTable;


// WEBPACK FOOTER //
// ./src/components/common/Tables/AdminTable.jsx